export default __webpack_public_path__ + "static/media/addIconLight.2f4a325d.svg";